export default function validate(values) {
  const { email } = values;

  return {
    email:
      (!email && 'Masukkan email') ||
      (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email) &&
        'Email tidak valid'),
  };
}
